import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AplicationErrorService {

  private errorMsg: string = "";

  constructor() { }

  getErrorMsg():string {
    return this.errorMsg;
  }

  setErrorMsg(msg: string): void {
    this.errorMsg = msg;
  }

}
